import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';

import {FeatureSelect} from './featureSelect';

import info from '../../../icons/info';

@customElement('feature-color-select')
export class FeatureColorSelect extends FeatureSelect {

	static styles = [
		FeatureSelect.styles,
		css`
			:host {

			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.values {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(var(--height-widget), 1fr));
				border: none;
			}

			.info {
				color: var(--color-widget-infoicon);
				background-color: transparent;
				cursor: pointer;
				transition: background-color 0.4s, color 0.4s;
				border: none;
				padding: 0;
			}

			.info:hover {
				color: var(--color-widget-text);
			}

			.info svg path {
				fill: currentColor;
				stroke: currentColor;
			}

			.info svg circle {
				stroke: currentColor;
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.icon.satisfied {
				color: var(--color-grey5);
			}

			.notSatisfied {
				color: var(--color-warn);
			}

			@media (max-width: 768px) {
				.item button {
					width: 100%;
				}

				.title span.selectedValue {
					display: none;
				}
        `];

	render() {
		return html`
			<div>
				<div class="title">
					<trans-label
							key="${this.feature.variableId}"
							context="F"
							title="${this.feature.variableId}">
					</trans-label>
					${when(this.hasFeatureDescription(), () => html`
						<button class="info" @click="${this.openModal}">
							${info}
						</button>
					`)}
					<span class="selectedValue">
						${this.selectedFeatureValue().map(value => html`
							<trans-label
									key="${this.feature.variableId}"
									context="FV">
							</trans-label>
						`)}
					</span>
				</div>
				<div class="values ${classMap({highlight: this.isHighlight(), notSatisfied: !this.isSatisfied()})}">
					${repeat([...this.feature.values]
									// .filter(value => !value.disabled)
									.sort((a, b) => this.getProductData(a.featureValueId)?.displaySequenceUi - this.getProductData(b.featureValueId)?.displaySequenceUi),
							(featureValue) => featureValue.featureValueId,
							(featureValue) => html`
								<feature-color-select-item .feature=${this.feature}
														   .featureValue=${featureValue}
														   .productData=${this.getProductData(featureValue.featureValueId)}>
								</feature-color-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
